import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://oigfmeizxipcguccuqha.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9pZ2ZtZWl6eGlwY2d1Y2N1cWhhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU1Nzk3MDcsImV4cCI6MjA1MTE1NTcwN30.h9zqFYKj1tToiroNweRx088gDOROBWBZ5tM664fbJIg';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper functions for common Supabase operations
export const checkSupabaseConnection = async () => {
  console.log('Tentando conectar ao Supabase...');
  console.log('URL:', supabaseUrl);
  
  try {
    const { data: { count }, error } = await supabase
      .from('clients')
      .select('*', { count: 'exact', head: true });
    
    if (error) {
      console.error('Erro na conexão com Supabase:', error.message);
      console.error('Detalhes do erro:', error);
      return false;
    }
    
    console.log('Conexão com Supabase estabelecida com sucesso!');
    console.log('Número de clientes na base:', count);
    return true;
  } catch (error) {
    console.error('Erro ao verificar conexão:', error.message);
    console.error('Detalhes do erro:', error);
    return false;
  }
};
